export const apiPrefix = '/v1/editor/'
export const mediaApiPrefix = '/v1/editor/media/'
